<template>
  <div class="l-docBox__menu">
    <ul class="l-userSelectList">
      <li :class="{ 'is-current' : path == directory.name }" v-for="(directory, index) in directoryList" :key="index" @click="onClick(directory.name, directory.pathArrayForDisplay)">
        <a>{{ directory.name }}</a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  components: {
  },
  data() {
    return {
      isProcessing: false,
      directoryList: [],
    }
  },
  computed: {
    path() {
      return this.$store.getters['doc/getPath'];
    }
  },
  created: async function() {
    await this.getDocList();
  },
  methods: {
    async getDocList() {
      this.isProcessing = true;
      let res = await this.$axios.post('/ld/api/document/getDocRootDirectoryList', {});
      if (res) {
        this.directoryList = res.data.directoryList;
      }
      this.isProcessing = false;
    },
    onClick(name, pathArrayForDisplay) {
      this.$store.dispatch('doc/setPath', name);
      this.$store.dispatch('doc/setPathArrayForDisplay', pathArrayForDisplay)
      this.$store.dispatch('doc/setIsSearchMode', false);
    },
  }
}
</script>